import type { ServerResponse } from 'http'

// Previews render member-authored HTML; never add allow-same-origin.
export const STOREFRONT_PREVIEW_SANDBOX =
    'allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox'

export const isStorefrontPreviewPath = (pathname: string) =>
    pathname === '/admin-editor-preview' ||
    pathname === '/admin-product-preview' ||
    pathname.startsWith('/preview/land/')

export const setStorefrontPreviewHeaders = (res: ServerResponse) => {
    const isDev = process.env.VERCEL_ENV !== 'production'
    const frameAncestors = isDev
        ? `'self' localhost:* https://*.vercel.app`
        : `'self' https://*.blackcrow.ai`

    res.setHeader(
        'Content-Security-Policy',
        `frame-ancestors ${frameAncestors}; sandbox ${STOREFRONT_PREVIEW_SANDBOX};`,
    )
    res.setHeader(
        'Cache-Control',
        'no-store, no-cache, max-age=0, s-maxage=0, must-revalidate, proxy-revalidate',
    )
}
